import React, { useState, useEffect } from 'react';

const MaterialReport: React.FC = () => {
  const [appliedTimeperiod, setAppliedTimeperiod] = useState<any>(null);
  const [facilityType, setFacilityType] = useState<'all' | 'dropdown'>('all');
  const [categoryType, setCategoryType] = useState<'all' | 'dropdown'>('all');
  const [itemType, setItemType] = useState<'all' | 'dropdown'>('all');
  const [transactionType, setTransactionType] = useState<string>('');
  const [timeperiod, setTimePeriod] = useState<'year' | 'month' | 'dateRange'>('year');
  const [selectedFacility, setSelectedFacility] = useState<string>('');
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [selectedYear, setSelectedYear] = useState<string>('');
  const [selectedMonth, setSelectedMonth] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  const [apiResponse, setApiResponse] = useState<any>(null);

  const [categories, setCategories] = useState<any[]>([]);
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const getFranchiseId = () => {
    const authData = localStorage.getItem('kt-auth-react-v');
    if (authData) {
      const parsedData = JSON.parse(authData);
      return parsedData.data?.franchiseeid || parsedData.data?.franchiseId;
    }
    return null;
  };
  const fetchCategories = async () => {
    // console.log('fetchCategories function called');

    const token = getAuthToken();
    const franchiseeid = getFranchiseId(); // Use the new function

    // console.log('Token retrieved:', token ? 'Token exists' : 'No token');
    // console.log('Franchise ID:', franchiseeid);

    if (!token || !franchiseeid) {
      console.log('Missing token or franchiseeid, returning early');
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}clients/101212/categories?page=0&size=100`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'franchiseeid': franchiseeid
        }
      });

      // console.log('Response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Categories data:', data);

      setCategories(data.data || data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchItems = async (categoryIds: string[]) => {
    const token = getAuthToken();
    const franchiseeid = getFranchiseId(); // Updated this line

    if (!token || !franchiseeid || categoryIds.length === 0) return;

    try {
      setLoading(true);
      const allItems: any[] = [];

      for (const categoryId of categoryIds) {
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}categories/${categoryId}/items?page=0&size=100`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'franchiseeid': franchiseeid
          }
        });
        const data = await response.json();
        const itemsData = data.data || data;
        if (Array.isArray(itemsData)) {
          allItems.push(...itemsData);
        }
      }

      const uniqueItems = allItems.filter((item, index, self) =>
        index === self.findIndex((i) => (i.id || i._id) === (item.id || item._id))
      );

      setItems(uniqueItems);
    } catch (error) {
      console.error('Error fetching items:', error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
  // Function to fetch all items when "All" is selected
  // const fetchAllItems = async () => {
  //   const token = getAuthToken();
  //   if (!token) return;

  //   try {
  //     setLoading(true);

  //     // Since /items endpoint might not exist, directly fetch from all categories
  //     if (categories.length > 0) {
  //       const allCategoryIds = categories.map(cat => cat.id || cat._id);
  //       await fetchItems(allCategoryIds);
  //     } else {
  //       // Fallback: try the direct items endpoint
  //       try {
  //         const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}items?page=0&size=1000`, {
  //           headers: {
  //             'Authorization': `Bearer ${token}`,
  //             'Content-Type': 'application/json'
  //           }
  //         });
  //         const data = await response.json();
  //         const itemsData = data.data || data || [];
  //         setItems(Array.isArray(itemsData) ? itemsData : []);
  //       } catch (error) {
  //         console.error('Direct items endpoint failed:', error);
  //         setItems([]);
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error fetching all items:', error);
  //     setItems([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  const fetchAllItems = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);

      if (categories.length > 0) {
        const allCategoryIds = categories.map(cat => cat.id || cat._id);
        await fetchItems(allCategoryIds);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.error('Error fetching all items:', error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, []);

  // Fetch items when categories change
  useEffect(() => {
    if (categoryType === 'dropdown' && selectedCategories.length > 0) {
      fetchItems(selectedCategories);
    } else if (categoryType === 'all' && categories.length > 0) {
      // When "All" categories is selected, fetch items from all categories
      const allCategoryIds = categories.map(cat => cat.id || cat._id);
      fetchItems(allCategoryIds);
    } else if (itemType === 'all' && categoryType === 'all') {
      // When both categories and items are "All", try to fetch all items directly
      fetchAllItems();
    } else {
      setItems([]);
    }
  }, [selectedCategories, categoryType, categories, itemType]);

  // Reset selections when type changes
  useEffect(() => {
    if (categoryType === 'all') {
      setSelectedCategories([]);
    }
  }, [categoryType]);

  useEffect(() => {
    if (itemType === 'all') {
      setSelectedItems([]);
    }
  }, [itemType]);




  const getAuthToken = () => {
    const authData = localStorage.getItem('kt-auth-react-v');
    if (authData) {
      const parsedData = JSON.parse(authData);
      return parsedData.data?.token;
    }
    return null;
  };

  const handleCategoryChange = (categoryId: string) => {
    setSelectedCategories(prev => {
      if (prev.includes(categoryId)) {
        return prev.filter(id => id !== categoryId);
      } else {
        return [...prev, categoryId];
      }
    });
  };

  // Handle item selection
  const handleItemChange = (itemId: string) => {
    setSelectedItems(prev => {
      if (prev.includes(itemId)) {
        return prev.filter(id => id !== itemId);
      } else {
        return [...prev, itemId];
      }
    });
  };

  // const handleApply = async () => {
  //   console.log('Apply button clicked!');
  //   const token = getAuthToken();
  //   console.log('Token:', token);

  //   if (!token || !transactionType) {
  //     alert('Please select a transaction type');
  //     return;
  //   }

  //   // Get category IDs
  //   let categoryIds: string[] = [];
  //   if (categoryType === 'all') {
  //     categoryIds = categories.map(cat => cat.id || cat._id);
  //   } else {
  //     categoryIds = selectedCategories;
  //   }

  //   // Get item IDs
  //   let itemIds: string[] = [];
  //   if (itemType === 'all') {
  //     itemIds = Array.isArray(items) ? items.map(item => item.id || item._id) : [];
  //   } else {
  //     itemIds = selectedItems;
  //   }

  //   console.log('Category Type:', categoryType);
  //   console.log('Item type:', itemType);
  //   console.log('Categories array length:', categories.length);
  //   console.log('Items array length:', Array.isArray(items) ? items.length : 'not array');
  //   console.log('Category IDs:', categoryIds);
  //   console.log('Item IDs:', itemIds);

  //   // Construct query parameters for URL
  //   const queryParams = new URLSearchParams();

  //   if (categoryIds.length > 0) {
  //     queryParams.append('categoryId', categoryIds.join(','));
  //   }
  //   if (itemIds.length > 0) {
  //     queryParams.append('itemId', itemIds.join(','));
  //   }
  //   if (timeperiod === 'year' && selectedYear) {
  //     queryParams.append('year', selectedYear);
  //   } else if (timeperiod === 'month' && selectedMonth && selectedYear) {
  //     queryParams.append('year', selectedYear);
  //     queryParams.append('month', selectedMonth);
  //   } else if (timeperiod === 'dateRange' && startDate && endDate) {
  //     queryParams.append('startDate', startDate);
  //     queryParams.append('endDate', endDate);
  //   }

  //   // Construct request body
  //   const requestBody: any = {
  //     franchiseId: "66d5382f62b417173d356f71"
  //   };

  //   // Add category and item IDs to payload
  //   if (categoryIds.length > 0) {
  //     requestBody.categoryIds = categoryIds.join(',');
  //   }
  //   if (itemIds.length > 0) {
  //     requestBody.itemIds = itemIds.join(',');
  //   }

  //   // Add time period to payload
  //   if (timeperiod === 'year' && selectedYear) {
  //     requestBody.year = parseInt(selectedYear);
  //   } else if (timeperiod === 'month' && selectedMonth && selectedYear) {
  //     requestBody.year = parseInt(selectedYear);
  //     requestBody.month = selectedMonth;
  //   } else if (timeperiod === 'dateRange' && startDate && endDate) {
  //     requestBody.startDate = startDate;
  //     requestBody.endDate = endDate;
  //   }

  //   // Add subtype based on transaction type
  //   if (selectedSubtype) {
  //     if (transactionType === 'DISPATCH') {
  //       requestBody.dispatchType = selectedSubtype;
  //     } else if (transactionType === 'COLLECTION') {
  //       requestBody.wasteSource = selectedSubtype;
  //     } else if (transactionType === 'PRODUCTION') {
  //       requestBody.processType = selectedSubtype;
  //     }
  //   }

  //   const apiUrl = `${process.env.REACT_APP_BASE_API_URL}itemAnalytics/${transactionType}?${queryParams.toString()}`;
  //   console.log('API URL:', apiUrl);
  //   console.log('Request Body:', requestBody);

  //   try {
  //     setLoading(true);
  //     console.log('Making API call...');

  //     const response = await fetch(apiUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Authorization': `Bearer ${token}`,
  //         'Content-Type': 'application/json',
  //         'franchiseId': '66d5382f62b417173d356f71'
  //       },
  //       body: JSON.stringify(requestBody)
  //     });

  //     console.log('Response status:', response.status);
  //     const data = await response.json();
  //     console.log('API Response:', data);

  //   } catch (error) {
  //     console.error('Error calling API:', error);
  //     alert('Error occurred: ' + (error instanceof Error ? error.message : 'Unknown error'));
  //   } finally {
  //     setLoading(false);
  //     console.log('Loading finished');
  //   }
  // };

  const handleApply = async () => {

    const token = getAuthToken();

    if (!token || !transactionType) {
      // alert('Please select a transaction type');
      return;
    }



    // Get category IDs
    let categoryIds: string[] = [];
    if (categoryType === 'all') {
      categoryIds = categories.map(cat => cat.id || cat._id);
    } else {
      categoryIds = selectedCategories;
    }

    // Get item IDs
    let itemIds: string[] = [];
    if (itemType === 'all') {
      itemIds = Array.isArray(items) ? items.map(item => item.id || item._id) : [];
    } else {
      itemIds = selectedItems;
    }
    const queryParams = new URLSearchParams();

    if (categoryIds.length > 0) {
      queryParams.append('categoryId', categoryIds.join(','));
    }
    if (itemIds.length > 0) {
      queryParams.append('itemId', itemIds.join(','));
    }
    if (timeperiod === 'year' && selectedYear) {
      queryParams.append('year', selectedYear);
    } else if (timeperiod === 'month' && selectedMonth) {
      const currentYear = new Date().getFullYear().toString();
      const monthNumber = new Date(`${selectedMonth} 1, 2000`).getMonth() + 1;
      const formattedMonth = monthNumber.toString().padStart(2, '0');
      queryParams.append('month', `${formattedMonth}/${currentYear}`);
    } else if (timeperiod === 'dateRange' && startDate && endDate) {
      const formatDate = (dateStr: string) => {
        const date = new Date(dateStr);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      };

      queryParams.append('startDate', formatDate(startDate));
      queryParams.append('endDate', formatDate(endDate));
    }

    const requestBody: any = {
      franchiseId: getFranchiseId() // Use the function instead of hardcoded value
    };
    const getUserType = () => {
      const authData = localStorage.getItem('kt-auth-react-v');
      if (authData) {
        const parsedData = JSON.parse(authData);
        return parsedData.data?.userType;
      }
      return null;
    };
    const userType = getUserType();
    const getPickupPointId = () => {
      const authData = localStorage.getItem('kt-auth-react-v');
      if (authData) {
        const parsedData = JSON.parse(authData);
        return parsedData.data?.pickupPointId || parsedData.data?.pickuppointid;
      }
      return null;
    };
    if (userType === "PICKUP_POINT_STAFF") {
      requestBody.pickuppointid = getPickupPointId();
      requestBody.franchiseId = null;
    } else {
      requestBody.franchiseId = getFranchiseId();
    }

    // Add category and item IDs to payload
    if (categoryIds.length > 0) {
      requestBody.categoryIds = categoryIds.join(',');
    }
    if (itemIds.length > 0) {
      requestBody.itemIds = itemIds.join(',');
    }

    // Add time period to payload
    if (timeperiod === 'year' && selectedYear) {
      requestBody.year = parseInt(selectedYear);
    } else if (timeperiod === 'month' && selectedMonth) {
      const currentYear = new Date().getFullYear().toString();
      const monthNumber = new Date(`${selectedMonth} 1, 2000`).getMonth() + 1;
      const formattedMonth = monthNumber.toString().padStart(2, '0');
      console.log('Adding month to payload:', `${formattedMonth}/${currentYear}`);
      requestBody.month = `${formattedMonth}/${currentYear}`;
    } else if (timeperiod === 'dateRange' && startDate && endDate) {
      const formatDate = (dateStr: string) => {
        const date = new Date(dateStr);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      };

      requestBody.startDate = formatDate(startDate);
      requestBody.endDate = formatDate(endDate);
    }

    // Add subtype based on transaction type
    if (transactionType === 'COLLECTION') {
      requestBody.wasteSource = 'C2B';
    } else if (transactionType === 'DISPATCH') {
      requestBody.dispatchType = 'CONVERT';
    } else if (transactionType === 'STOCK_TRANSFER') {
      requestBody.wasteSource = 'B2B';
      requestBody.dispatchType = 'RETURN';
    }



    let apiTransactionType = transactionType;
    if (transactionType === 'DISPATCH' || transactionType === 'STOCK_TRANSFER') {
      apiTransactionType = 'DISPATCH';
    }

    const apiUrl = `${process.env.REACT_APP_BASE_API_URL}itemAnalytics/${apiTransactionType}?${queryParams.toString()}`;
    console.log('API URL:', apiUrl);
    console.log('Request Body:', requestBody);

    try {
      setLoading(true);
      console.log('Making API call...');

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'franchiseId': '66d5382f62b417173d356f71'
        },
        body: JSON.stringify(requestBody)
      });

      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('API Response:', data);
      setApiResponse(data);

      setAppliedTimeperiod({
        type: timeperiod,
        year: selectedYear,
        month: selectedMonth,
        startDate: startDate,
        endDate: endDate
      });

    } catch (error) {
      console.error('Error calling API:', error);
      alert('Error occurred: ' + (error instanceof Error ? error.message : 'Unknown error'));
    } finally {
      setLoading(false);
      console.log('Loading finished');
    }
  };

  useEffect(() => {
    setApiResponse(null);
    if (timeperiod === 'dateRange') {
      setSelectedMonth('');
      setSelectedYear('');
    } else if (timeperiod === 'year') {
      setSelectedMonth('');
      setStartDate('');
      setEndDate('');
      // Don't clear selectedYear here since year option uses it
    } else if (timeperiod === 'month') {
      setSelectedYear(''); // Clear year when switching to month
      setStartDate('');
      setEndDate('');
    }
  }, [timeperiod]);


  return (
    <div className="p-6 bg-white">
      <div className="space-y-6">
        {/* Category Row */}


        {/* <div className="grid grid-cols-12 gap-4 items-start">
          <label className="font-semibold col-span-2 mt-2">Category</label>
          <div className="col-span-10 space-y-4">
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="category"
                  checked={categoryType === 'all'}
                  onChange={() => setCategoryType('all')}
                  className="w-5 h-5"
                />
                <span className="text-gray-700">All</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="category"
                  checked={categoryType === 'dropdown'}
                  onChange={() => setCategoryType('dropdown')}
                  className="w-5 h-5"
                />
                <span className="text-gray-700">Select Categories</span>
              </label>
            </div>

            {categoryType === 'dropdown' && (
              <div className="border rounded-lg p-4 max-h-48 overflow-y-auto">
                <div className="text-sm text-gray-600 mb-2">Select one or more categories:</div>
                {categories.map((category) => (
                  <label key={category.id || category._id} className="flex items-center gap-2 py-1">
                    <input
                      type="checkbox"
                      checked={selectedCategories.includes(category.id || category._id)}
                      onChange={() => handleCategoryChange(category.id || category._id)}
                      className="w-4 h-4"
                    />
                    <span>{category.name}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        </div> */}

        {/* Category Row */}
        <div className="grid grid-cols-12 gap-4 items-start">
          <label className="font-semibold col-span-2 mt-2">Category</label>
          <div className="col-span-10 space-y-4">
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="category"
                  checked={categoryType === 'all'}
                  onChange={() => setCategoryType('all')}
                  className="w-5 h-5"
                />
                <span className="text-gray-700">All</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="category"
                  checked={categoryType === 'dropdown'}
                  onChange={() => setCategoryType('dropdown')}
                  className="w-5 h-5"
                />
                <span className="text-gray-700">Select Categories</span>
              </label>
            </div>

            {categoryType === 'dropdown' && (
              <div style={{
                border: '1px solid #ddd',
                borderRadius: '4px',
                minHeight: '40px',
                padding: '8px',
                background: 'white',
                cursor: 'text'
              }}>
                {/* Selected Tags */}
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '4px',
                  marginBottom: '8px'
                }}>
                  {selectedCategories.map((categoryId) => {
                    const category = categories.find(cat => (cat.id || cat._id) === categoryId);
                    return (
                      <span key={categoryId} style={{
                        background: '#f8f9fa',
                        borderRadius: '6px',
                        padding: '3px 8px',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        border: '1px solid #e9ecef'
                      }}>
                        {category?.name}
                        <span
                          style={{
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            color: '#666',
                            fontSize: '14px'
                          }}
                          onClick={() => handleCategoryChange(categoryId)}
                        >
                          ×
                        </span>
                      </span>
                    );
                  })}
                </div>

                {/* Dropdown Options */}
                <div style={{
                  maxHeight: '200px',
                  overflowY: 'auto',
                  borderTop: selectedCategories.length > 0 ? '1px solid #eee' : 'none',
                  paddingTop: selectedCategories.length > 0 ? '8px' : '0'
                }}>
                  {/* <div className="mb-7 row">
                    {categories.map((eachCategory, idx) => (
                      <div key={idx + 1 + ''} className='d-flex col-6'>
                        <div className='form-check form-check-custom form-check-solid'>
                          <input
                            className='form-check-input me-3'
                            name={eachCategory.id || eachCategory._id}
                            type='checkbox'
                            value={eachCategory.id || eachCategory._id}
                            onClick={() => handleCategoryChange(eachCategory.id || eachCategory._id)}
                            id={'kt_modal_update_category_option_' + idx}
                            checked={selectedCategories.includes(eachCategory.id || eachCategory._id)}
                            disabled={loading}
                          />
                          <label className='form-check-label' htmlFor={'kt_modal_update_category_option_' + idx}>
                            <div className='fw-bolder text-gray-800'>{eachCategory.name}</div>
                          </label>
                          <div className='separator separator-dashed my-5'></div>
                        </div>
                      </div>
                    ))}
                  </div> */}
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '8px 12px',
                    alignItems: 'flex-start'
                  }}>
                    {categories.map((eachCategory, idx) => (
                      <div key={idx + 1 + ''} style={{
                        minWidth: '180px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}>
                        <input
                          className='form-check-input'
                          name={eachCategory.id || eachCategory._id}
                          type='checkbox'
                          value={eachCategory.id || eachCategory._id}
                          onClick={() => handleCategoryChange(eachCategory.id || eachCategory._id)}
                          id={'kt_modal_update_category_option_' + idx}
                          checked={selectedCategories.includes(eachCategory.id || eachCategory._id)}
                          disabled={loading}
                          style={{
                            margin: '0',
                            position: 'static'
                          }}
                        />
                        <label className='form-check-label' htmlFor={'kt_modal_update_category_option_' + idx} style={{ margin: '0' }}>
                          <span className='fw-bolder text-gray-800' style={{
                            wordWrap: 'break-word',
                            lineHeight: '1.2'
                          }}>
                            {eachCategory.name}
                          </span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Item Row */}
        {/* <div className="grid grid-cols-12 gap-4 items-start">
          <label className="font-semibold col-span-2 mt-2">Item</label>
          <div className="col-span-10 space-y-4">
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="item"
                  checked={itemType === 'all'}
                  onChange={() => setItemType('all')}
                  className="w-5 h-5"
                />
                <span className="text-gray-700">All</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="item"
                  checked={itemType === 'dropdown'}
                  onChange={() => setItemType('dropdown')}
                  className="w-5 h-5"
                />
                <span className="text-gray-700">Select Items</span>
              </label>
            </div>

            {itemType === 'dropdown' && (
              <div className="border rounded-lg p-4 max-h-48 overflow-y-auto">
                <div className="text-sm text-gray-600 mb-2">Select one or more items:</div>
                {Array.isArray(items) && items.length > 0 ? (
                  items.map((item) => (
                    <label key={item.id || item._id} className="flex items-center gap-2 py-1">
                      <input
                        type="checkbox"
                        checked={selectedItems.includes(item.id || item._id)}
                        onChange={() => handleItemChange(item.id || item._id)}
                        className="w-4 h-4"
                      />
                      <span>{item.name}</span>
                    </label>
                  ))
                ) : (
                  <div className="text-gray-500 text-sm">
                    {categoryType === 'dropdown' && selectedCategories.length === 0
                      ? "Please select categories first"
                      : "No items available"
                    }
                  </div>
                )}
              </div>
            )}
          </div>
        </div> */}

        {/* Item Row */}
        <div className="grid grid-cols-12 gap-4 items-start">
          <label className="font-semibold col-span-2 mt-2">Item</label>
          <div className="col-span-10 space-y-4">
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="item"
                  checked={itemType === 'all'}
                  onChange={() => setItemType('all')}
                  className="w-5 h-5"
                />
                <span className="text-gray-700">All</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="item"
                  checked={itemType === 'dropdown'}
                  onChange={() => setItemType('dropdown')}
                  className="w-5 h-5"
                />
                <span className="text-gray-700">Select Items</span>
              </label>
            </div>

            {itemType === 'dropdown' && (
              <div style={{
                border: '1px solid #ddd',
                borderRadius: '4px',
                minHeight: '40px',
                padding: '8px',
                background: 'white',
                cursor: 'text'
              }}>
                {/* Selected Tags */}
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '4px',
                  marginBottom: '8px'
                }}>
                  {selectedItems.map((itemId) => {
                    const item = items.find(itm => (itm.id || itm._id) === itemId);
                    return (
                      <span key={itemId} style={{
                        background: '#f8f9fa',
                        borderRadius: '6px',
                        padding: '3px 8px',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        border: '1px solid #e9ecef'
                      }}>
                        {item?.name}
                        <span
                          style={{
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            color: '#666',
                            fontSize: '14px'
                          }}
                          onClick={() => handleItemChange(itemId)}
                        >
                          ×
                        </span>
                      </span>
                    );
                  })}
                </div>

                {/* Dropdown Options */}
                <div style={{
                  maxHeight: '200px',
                  overflowY: 'auto',
                  borderTop: selectedItems.length > 0 ? '1px solid #eee' : 'none',
                  paddingTop: selectedItems.length > 0 ? '8px' : '0'
                }}>
                  {/* <div className="mb-7 row">
                    {Array.isArray(items) && items.length > 0 ? (
                      items.map((eachItem, idx) => (
                        <div key={idx + 1 + ''} className='d-flex col-6'>
                          <div className='form-check form-check-custom form-check-solid'>
                            <input
                              className='form-check-input me-3'
                              name={eachItem.id || eachItem._id}
                              type='checkbox'
                              value={eachItem.id || eachItem._id}
                              onClick={() => handleItemChange(eachItem.id || eachItem._id)}
                              id={'kt_modal_update_item_option_' + idx}
                              checked={selectedItems.includes(eachItem.id || eachItem._id)}
                              disabled={loading}
                            />
                            <label className='form-check-label' htmlFor={'kt_modal_update_item_option_' + idx}>
                              <div className='fw-bolder text-gray-800'>{eachItem.name}</div>
                            </label>
                            <div className='separator separator-dashed my-5'></div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-gray-500 text-sm ml-4">
                        {categoryType === 'dropdown' && selectedCategories.length === 0
                          ? "Please select categories first"
                          : "No items available"
                        }
                      </div>
                    )}
                  </div> */}
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '8px 12px',
                    alignItems: 'flex-start'
                  }}>
                    {Array.isArray(items) && items.length > 0 ? (
                      items.map((eachItem, idx) => (
                        <div key={idx + 1 + ''} style={{
                          minWidth: '180px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}>
                          <input
                            className='form-check-input'
                            name={eachItem.id || eachItem._id}
                            type='checkbox'
                            value={eachItem.id || eachItem._id}
                            onClick={() => handleItemChange(eachItem.id || eachItem._id)}
                            id={'kt_modal_update_item_option_' + idx}
                            checked={selectedItems.includes(eachItem.id || eachItem._id)}
                            disabled={loading}
                            style={{
                              margin: '0',
                              position: 'static'
                            }}
                          />
                          <label className='form-check-label' htmlFor={'kt_modal_update_item_option_' + idx} style={{ margin: '0' }}>
                            <span className='fw-bolder text-gray-800' style={{
                              wordWrap: 'break-word',
                              lineHeight: '1.2'
                            }}>
                              {eachItem.name}
                            </span>
                          </label>
                        </div>
                      ))
                    ) : (
                      <div className="text-gray-500 text-sm ml-4">
                        {categoryType === 'dropdown' && selectedCategories.length === 0
                          ? "Please select categories first"
                          : "No items available"
                        }
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Transaction type Row */}
        {/* <div className="grid grid-cols-12 gap-4 items-center">
          <label className="font-semibold col-span-2">Transaction type</label>
          <div className="col-span-10 flex items-center gap-6 flex-wrap">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="transaction"
                value="PRODUCTION"
                checked={transactionType === 'PRODUCTION'}
                onChange={(e) => setTransactionType(e.target.value)}
                className="w-5 h-5"
              />
              <span>Processing</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="transaction"
                value="DISPATCH"
                checked={transactionType === 'DISPATCH'}
                onChange={(e) => setTransactionType(e.target.value)}
                className="w-5 h-5"
              />
              <span>External Sale</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="transaction"
                value="COLLECTION"
                checked={transactionType === 'COLLECTION'}
                onChange={(e) => setTransactionType(e.target.value)}
                className="w-5 h-5"
              />
              <span>Collection</span>
            </label>
          </div>
        </div> */}



        <div className="grid grid-cols-12 gap-4 items-center">
          <label className="font-semibold col-span-2">Transaction type</label>
          <div className="col-span-10 flex items-center gap-6 flex-wrap">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="transaction"
                value="PRODUCTION"
                checked={transactionType === 'PRODUCTION'}
                onChange={(e) => setTransactionType(e.target.value)}
                className="w-5 h-5"
              />
              <span>Processing</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="transaction"
                value="DISPATCH"
                checked={transactionType === 'DISPATCH'}
                onChange={(e) => setTransactionType(e.target.value)}
                className="w-5 h-5"
              />
              <span>External Sale</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="transaction"
                value="COLLECTION"
                checked={transactionType === 'COLLECTION'}
                onChange={(e) => setTransactionType(e.target.value)}
                className="w-5 h-5"
              />
              <span>Collection</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="transaction"
                value="STOCK_TRANSFER"
                checked={transactionType === 'STOCK_TRANSFER'}
                onChange={(e) => setTransactionType(e.target.value)}
                className="w-5 h-5"
              />
              <span>Stock transfer</span>
            </label>
          </div>
        </div>

        {/* Add this warning message */}
        {!transactionType && (
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-2"></div>
            <div className="col-span-10">
              <span className="text-red-500 text-sm">Please select a transaction type</span>
            </div>
          </div>
        )}

        {/* Select Time Period Row */}
        {/* <div className="grid grid-cols-12 gap-4 items-start">
          <label className="font-semibold col-span-2 mt-2">Select Time Period</label>
          <div className="col-span-10 space-y-4">
           
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2 min-w-20">
                <input
                  type="radio"
                  name="timeperiod"
                  value="year"
                  checked={timeperiod === 'year'}
                  onChange={(e) => setTimePeriod(e.target.value as 'year')}
                  className="w-5 h-5"
                />
                <span>Year</span>
              </label>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                disabled={timeperiod !== 'year'}
                className="px-4 py-2 border-2 rounded bg-white disabled:opacity-50 min-w-40"
              >
                <option value="">Select Year</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
              </select>
            </div>

           
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2 min-w-20">
                <input
                  type="radio"
                  name="timeperiod"
                  value="month"
                  checked={timeperiod === 'month'}
                  onChange={(e) => setTimePeriod(e.target.value as 'month')}
                  className="w-5 h-5"
                />
                <span>Month</span>
              </label>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                disabled={timeperiod !== 'month'}
                className="px-4 py-2 border-2 rounded bg-white disabled:opacity-50 min-w-40"
              >
                <option value="">Select Month</option>
                <option value="january">January</option>
                <option value="february">February</option>
                <option value="march">March</option>
                <option value="april">April</option>
                <option value="may">May</option>
                <option value="june">June</option>
                <option value="july">July</option>
                <option value="august">August</option>
                <option value="september">September</option>
                <option value="october">October</option>
                <option value="november">November</option>
                <option value="december">December</option>
              </select>
            </div>

           
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2 min-w-20">
                <input
                  type="radio"
                  name="timeperiod"
                  value="dateRange"
                  checked={timeperiod === 'dateRange'}
                  onChange={(e) => setTimePeriod(e.target.value as 'dateRange')}
                  className="w-5 h-5"
                />
                <span>Date Range</span>
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  disabled={timeperiod !== 'dateRange'}
                  placeholder="Start date"
                  className="px-4 py-2 border-2 rounded bg-white disabled:opacity-50"
                />
                <span className="text-gray-500">to</span>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  disabled={timeperiod !== 'dateRange'}
                  placeholder="End date"
                  className="px-4 py-2 border-2 rounded bg-white disabled:opacity-50"
                />
              </div>
            </div>
          </div>
        </div> */}

        {/* Select Time Period Row */}
        <div className="grid grid-cols-12 gap-4 items-start">
          <label className="font-semibold col-span-2 mt-2">Select Time Period</label>
          <div className="col-span-10 space-y-4">
            {/* All options in one line */}
            <div className="flex items-center gap-8 flex-wrap">
              {/* Year Option */}
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="timeperiod"
                    value="year"
                    checked={timeperiod === 'year'}
                    onChange={(e) => setTimePeriod(e.target.value as 'year')}
                    className="w-5 h-5"
                  />
                  <span>Year</span>
                </label>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  disabled={timeperiod !== 'year'}
                  className="px-4 py-2 border-2 rounded bg-white disabled:opacity-50 min-w-40"
                >
                  <option value="">Select Year</option>
                  <option value="2025">2025</option>
                  <option value="2024">2024</option>
                  <option value="2023">2023</option>
                  <option value="2022">2022</option>
                </select>
              </div>

              {/* Month Option */}
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="timeperiod"
                    value="month"
                    checked={timeperiod === 'month'}
                    onChange={(e) => setTimePeriod(e.target.value as 'month')}
                    className="w-5 h-5"
                  />
                  <span>Month</span>
                </label>
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  disabled={timeperiod !== 'month'}
                  className="px-4 py-2 border-2 rounded bg-white disabled:opacity-50 min-w-40"
                >
                  <option value="">Select Month</option>
                  <option value="january">January</option>
                  <option value="february">February</option>
                  <option value="march">March</option>
                  <option value="april">April</option>
                  <option value="may">May</option>
                  <option value="june">June</option>
                  <option value="july">July</option>
                  <option value="august">August</option>
                  <option value="september">September</option>
                  <option value="october">October</option>
                  <option value="november">November</option>
                  <option value="december">December</option>
                </select>
              </div>

              {/* Date Range Option */}
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="timeperiod"
                    value="dateRange"
                    checked={timeperiod === 'dateRange'}
                    onChange={(e) => setTimePeriod(e.target.value as 'dateRange')}
                    className="w-5 h-5"
                  />
                  <span>Date Range</span>
                </label>
                <div className="flex items-center gap-3">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    disabled={timeperiod !== 'dateRange'}
                    className="px-4 py-2 border-2 rounded bg-white disabled:opacity-50"
                  />
                  <span className="text-gray-500">to</span>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    disabled={timeperiod !== 'dateRange'}
                    className="px-4 py-2 border-2 rounded bg-white disabled:opacity-50"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="flex justify-end mt-8 pt-6 border-t">
          <button
            onClick={handleApply}
            disabled={loading}
            className="px-8 py-3 text-white rounded hover:bg-blue-700 transition-colors font-medium disabled:opacity-50"
            style={{ background: "black" }}
          >
            {loading ? 'Loading...' : 'Apply'}
          </button>
        </div>
      </div>



      {apiResponse && apiResponse.data && (
        <div className="card mt-8">
          {/* begin::Body */}
          <div className='card-body py-3'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4' style={{ tableLayout: 'fixed' }}>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bold text-dark'>
                    <th style={{ width: '16.66%' }}>Category</th>
                    <th style={{ width: '16.66%' }}>Item</th>
                    <th style={{ width: '16.66%' }}>Quantity</th>
                    <th style={{ width: '16.66%' }}>Period</th>
                    <th style={{ width: '16.66%' }}>Activity</th>
                    <th style={{ width: '16.66%' }}>Sub Type</th>
                  </tr>
                </thead>
                {/* end::Table head */}

                {/* begin::Table body */}
                <tbody>
                  {apiResponse.data.map((item: any, index: number) => (
                    <tr key={index}>
                      <td style={{ wordWrap: 'break-word' }}>{item.categoroyName}</td>
                      <td style={{ wordWrap: 'break-word' }}>{item.itemName}</td>
                      <td style={{ wordWrap: 'break-word' }}>{Number(item.quantity || 0).toFixed(2)}</td>
                      <td style={{ wordWrap: 'break-word' }}>
                        {appliedTimeperiod?.type === 'year' && appliedTimeperiod?.year ? appliedTimeperiod.year :
                          appliedTimeperiod?.type === 'month' && appliedTimeperiod?.month ?
                            `${(new Date(`${appliedTimeperiod.month} 1, 2000`).getMonth() + 1).toString().padStart(2, '0')} ${new Date().getFullYear()}` :
                            appliedTimeperiod?.type === 'dateRange' && appliedTimeperiod?.startDate && appliedTimeperiod?.endDate ?
                              `${appliedTimeperiod.startDate} to ${appliedTimeperiod.endDate}` : 'N/A'}
                      </td>
                      <td style={{ wordWrap: 'break-word' }}>-</td>
                      <td style={{ wordWrap: 'break-word' }}>
                        {transactionType === 'COLLECTION' ? 'First Collection' :
                          transactionType === 'STOCK_TRANSFER' ? 'Material Transfer' : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
            {/* end::Table container */}
          </div>
          {/* end::Body */}
        </div>
      )}
    </div>
  );
};

export default MaterialReport;